import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ErrorResponse } from '@sparkai/utils'

import { apiClient } from '../../apiClient'
import { PROGRAM_AVAILABILITY_WINDOW_KEY } from '../availability-window/useAvailabilityWindow'
import { PROGRAM_BY_ID_KEY } from '../useProgram'

type UpdateTimezoneRequest = {
  programId: string
  timezone: string
}

export type UpdateTimezoneResponse = {
  programId: string
  availabilityTimezone: string | null
}

export function useUpdateTimezone(onSuccess?: (data: UpdateTimezoneResponse) => void) {
  const queryClient = useQueryClient()

  return useMutation<UpdateTimezoneResponse, ErrorResponse, UpdateTimezoneRequest>({
    mutationFn: async ({ programId, timezone }) => {
      const { data } = await apiClient.put<UpdateTimezoneResponse>(`/int/v3/programs/${programId}/timezone`, {
        timezone,
      })
      return data
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [PROGRAM_BY_ID_KEY, data.programId] })
      queryClient.invalidateQueries({
        queryKey: [PROGRAM_AVAILABILITY_WINDOW_KEY, data.programId],
      })
      onSuccess?.(data)
    },
  })
}
